(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !window.DesignMode) return;
  try {
    
  document.querySelector('.collection-description-btn').addEventListener('click', (evt) => {
    const descriptionBox = document.querySelector('.collection-description-wrapper');
    if (descriptionBox.classList.contains('active')) {
      descriptionBox.classList.remove('active');
      evt.target.innerText = 'Show less';
    } else {
      descriptionBox.classList.add('active');
      evt.target.innerText = 'Show More';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
